import React, { useEffect, useState, useContext } from "react";
import { EnvironmentContext } from '../index';
import { Env1Context } from '../index';
import axios from 'axios';
import Swal from "sweetalert2";

import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Seo from "../Components/Seo";
import PricingCard from './PricingCard';
import PricingTable from "./PricingTable";

import arrow from "../img/down-arrow-30.png";
import frame from "../img/Frame.png";
import ticklite from "../img/tick-lite-24.png";
import ticklite1 from "../img/tick2.png";
import ticklite2 from "../img/tick3.png";
import ticklite3 from "../img/icons8-enterpr-24.png";

function Pricing() {
  const [pricingData, setPricingData] = useState({
    userAnnualPrice: 0,
    userMonthly: 0,
    companyAnnualPrice: 0,
    companyMonthly: 0,
    currencySymbol: ''
  });

  const [isYearly, setIsYearly] = useState(false);
  const [email, setEmail] = useState('');
  const [rememberMe, setRememberMe] = useState(true);

  const env = useContext(EnvironmentContext);
  const env1 = useContext(Env1Context);

  useEffect(() => {
    fetch(`${env1}/index1.php/api/users/unauth/packages`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data, "pppppppp");

        const individualUserData = data?.Entity?.filter(
          (item) => item.PackageCode === "IDIVIDUALUSER"
        );

        const smbPlanCompanyData = data?.Entity?.filter(
          (item) => item.PackageCode === "COMPANY"
        );

        const individualUserObj = individualUserData?.[0];
        const smbPlanCompanyObj = smbPlanCompanyData?.[0];

        const currencySymbolIndividual =
          individualUserObj?.CurrencySymbol === "?"
            ? "₹"
            : individualUserObj?.CurrencySymbol;

        setPricingData({
          userAnnualPrice: individualUserObj?.AnnualPrice || 0,
          userMonthly: individualUserObj?.MonthlyPrice || 0,
          companyAnnualPrice: smbPlanCompanyObj?.AnnualPrice || 0,
          companyMonthly: smbPlanCompanyObj?.MonthlyPrice || 0,
          currencySymbol: currencySymbolIndividual || ''
        });
      })
      .catch((error) => {
        console.error('Error fetching pricing data:', error);
      });
  }, [env1]);

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      Swal.fire({
        width: 500,
        text: "Please enter your email id.",
        confirmButtonText: 'OK',
      });
      return;
    }

    const payload = {
      Email: email,
      IsReact: 1,
      Isremeberme: rememberMe,
    };

    try {
      const response = await axios.post(
        `${env1}/index1.php/api/users/registerwithemail`,
        payload
      );

      if (response.data.Entity.isRegistered) {
        Swal.fire({
          width: 500,
          text: "Registered successfully...",
          confirmButtonText: 'OK',
        }).then(() => {
          setEmail('');
        });
      } else if (response.data.Entity.isUserAuthenticated) {
        Swal.fire({
          width: 500,
          text: "Entered email already exists, Please try with different email id.",
          confirmButtonText: 'OK',
          confirmButtonColor: "#0e91ef",
        }).then(() => {
          setEmail('');
        });
      }
    } catch (error) {
      Swal.fire({
        width: 500,
        text: "An error occurred. Please try again.",
        confirmButtonText: 'OK',
      });
    }
  };

  const handleToggleChange = () => {
    setIsYearly(!isYearly);
  };

  const generateLink = (packageCode, durationMode) => {
    return `${env}/account/register?packagecode=${packageCode}&durationmode=${durationMode}`;
  };

  return (
    <div>
      <Seo
        title="Electronic Signature Software Plans & Pricing | SignuluOne"
        description="Compare Signulu eSignature plans for individual users, small businesses and enterprises. Review document limits, workflow features and account options."
        keywords="eSignature software plans, Signulu pricing, electronic signature subscription, business eSignature cost, digital signing plans, enterprise eSignature pricing"
        canonical="https://signulu.signuluone.com/pricing"
      />
      <Header />

      <section className="pricing_box">
        <div className="container container-lg container-xl container-xxl">

          <div className="row">
            <div className="col-12">
              <div
                className="heading"
                data-aos="fade-up"
                data-aos-duration="1500"
              >
                <h2>
                  Signulu <span>Pricing</span>
                </h2>

                <p>
                  Whether you want to use Signulu as an Individual professional
                  or for a small or medium-sized organization or large
                  enterprise, we have a plan that fits your needs.
                </p>
              </div>
            </div>
          </div>

          <div
            className="pricing_card_box"
            data-aos="fade-up"
            data-aos-duration="1500"
            style={{ boxSizing: 'border-box' }}
          >
            <div className="cards-main-box">

              {/* SIGNULU LITE */}
              <PricingCard
                title="Signulu Lite"
                description="For a faster eSignature experience."
                price1="Free"
                features={[
                  { name: 'No. of Documents', value: '5 per month' },
                  { name: 'No. of Users', value: 'Single User' },
                  { name: 'No. of Recipients per Envelope', value: 2 },
                  { name: 'Max size of the envelope', value: '5 MB' },
                  'Send Documents for eSignature',
                  { name: 'Signing Workflows', value: <img src={ticklite} alt="" /> },
                  { name: 'Essential Document Fields', value: <img src={ticklite} alt="" /> },
                  { name: 'Audit Trail', value: <img src={ticklite} alt="" /> },
                  { name: 'Notification and Reminders', value: <img src={ticklite} alt="" /> },
                  { name: '2 recipients per Envelope', value: <img src={ticklite} alt="" /> },
                  { name: '1 Document per envelope', value: <img src={ticklite} alt="" /> },
                  { name: '5 MB max size per envelope', value: <img src={ticklite} alt="" /> }
                ]}
                link={`${env}/account/register`}
                backgroundClass="background_grey"
              />

              {/* INDIVIDUAL USER */}
              <PricingCard
                title="Individual User"
                description="For individual professionals to get the documents signed efficiently"
                currencySymbol={pricingData.currencySymbol}
                price={
                  isYearly
                    ? 59.88
                    : pricingData.userMonthly
                }
                duration={
                  isYearly
                    ? "per user per annum"
                    : "per user per month"
                }
                toggleSwitch
                isYearly={isYearly}
                handleToggleChange={handleToggleChange}
                features={[
                  { name: 'No. of Documents', value: '10 per month' },
                  { name: 'No. of Users', value: 'Single User' },
                  { name: 'No. of Recipients per Envelope', value: 5 },
                  { name: 'Max size of the envelope', value: '10 MB' },
                  'All Lite user features plus:',
                  { name: 'Templates', value: <img src={ticklite1} alt="" /> },
                  { name: 'Signing Workflows', value: <img src={ticklite1} alt="" /> },
                  { name: 'Essential Document Fields', value: <img src={ticklite1} alt="" /> },
                  { name: 'Audit Trail', value: <img src={ticklite1} alt="" /> },
                  { name: 'Notification and Reminders', value: <img src={ticklite1} alt="" /> },
                  { name: 'Payments', value: <img src={ticklite1} alt="" /> },
                  { name: 'Cloud Storage', value: <img src={ticklite1} alt="" /> },
                  { name: 'Basic reports', value: <img src={ticklite1} alt="" /> },
                  { name: '5 recipients per Envelope', value: <img src={ticklite1} alt="" /> },
                  { name: '3 Documents per envelope', value: <img src={ticklite1} alt="" /> },
                  { name: '10 MB max size per envelope', value: <img src={ticklite1} alt="" /> }
                ]}
                link={generateLink(
                  'IDIVIDUALUSER',
                  isYearly ? 'Annual' : 'Monthly'
                )}
                backgroundClass="background_org"
              />

              {/* SMB PLAN */}
              <PricingCard
                title="SMB Plan"
                description="For small and medium businesses to streamline their document signing process and drive efficiency within their organizations."
                contactPlan
                features={[
                  { name: 'No. of Documents', value: 'Unlimited' },
                  { name: 'No. of Users', value: 'Up to 5 users' },
                  'All Individual plan features plus:',
                  { name: 'Advanced Document Fields', value: <img src={ticklite2} alt="" /> },
                  { name: 'Multiple Language Sites.', value: <img src={ticklite2} alt="" /> },
                  { name: 'Mobile App', value: <img src={ticklite2} alt="" /> },
                  { name: 'Advanced reports.', value: <img src={ticklite2} alt="" /> }
                ]}
                link="./contact"
                backgroundClass="background_green"
              />

              {/* ENTERPRISE */}
              <PricingCard
                title="Enterprise"
                description="For large enterprises who are looking at document processing at scale with advanced features and with integration with other enterprise applications."
                contactPlan
                contactInfo
                features={[
                  { name: 'No. of Documents', value: 'Unlimited' },
                  { name: 'No. of Users', value: 'Custom Plan' },
                  'All SMB plan features plus:',
                  { name: 'API Integrations.', value: <img src={ticklite3} alt="" /> },
                  { name: 'SSO', value: <img src={ticklite3} alt="" /> },
                  { name: 'Custom Branding', value: <img src={ticklite3} alt="" /> },
                  { name: 'Document Authoring', value: <img src={ticklite3} alt="" /> }
                ]}
                link="./contact"
                backgroundClass="background_sky"
              />

            </div>

            <div
              style={{
                textAlign: 'center',
                paddingTop: '30px',
                paddingBottom: '30px'
              }}
            >
              <a
                href="#CompareAllFeatures"
                style={{
                  color: 'var(--sg-accent)',
                  textDecoration: 'none',
                  fontWeight: '700',
                  border: '1px solid var(--sg-navy-border)',
                  background: 'var(--sg-navy-bg)',
                  padding: '10px 18px',
                  borderRadius: 'var(--sg-radius-md)'
                }}
              >
                Compare All Features
                <img
                  src={arrow}
                  alt=""
                  style={{ marginLeft: '10px' }}
                />
              </a>
            </div>
          </div>

          <div className="row">
            <div
              className="priceing_all"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <h2>
                Simple, Fair and affordable digital{' '}
                <span>signature</span> services for all
              </h2>

              <p>
                Subscribe the plan that meet your business needs and budget
                with competitive pricing options.
              </p>
            </div>
          </div>

          <h3
            style={{
              textAlign: 'center',
              padding: '33px 0px'
            }}
            id="CompareAllFeatures"
          >
            Compare the plans
          </h3>

          <div>
            <PricingTable />
          </div>

        </div>
      </section>

      <section
        className="trial-box"
        data-aos="fade-up"
        data-aos-duration="2500"
      >
        <div className="container container-lg container-xl container-xxl">
          <div className="row background align-items-center justify-content-between m-0 trySignulu-inp-box">

            <div className="col-xl-6 col-md-12 text-mail">
              <h3>
                Get up to 5 documents signed for free, every month
              </h3>

              <p>
                Try Signulu eSignature for 14 days. No credit card required.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="your-email-id-box">
                  <input
                    type="email"
                    placeholder="Your email id"
                    className="email-inp-field"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />

                  <button
                    type="submit"
                    className="start-free-trail-with-email"
                  >
                    Start Trial
                  </button>
                </div>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    style={{
                      width: '20px',
                      height: '20px',
                      backgroundColor: '#FFFFFF',
                      border: 'blue'
                    }}
                    id="rememberme"
                    type="checkbox"
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)}
                  />

                  <p className="subscrib">
                    Subscribe to our Newsletters
                  </p>
                </div>

                <p className="no-card">
                  *No credit card required
                </p>
              </form>
            </div>

            <div className="col-xl-6 col-md-12 btn-part img-frame">
              <img
                src={frame}
                className="frame-img"
                alt=""
              />
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Pricing;
